import Router from 'preact-router';
import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';
import CustomerLanding from './pages/CustomerLanding';
import BusinessLanding from './pages/BusinessLanding';
import CenterRedirect from './pages/CenterRedirect';
import ProductRedirect from './pages/ProductRedirect';
import DownloadRedirect from './pages/DownloadRedirect';
import AdminAppDownloadRedirect from './pages/AdminAppDownloadRedirect';

export default function App() {
  const scrollToHash = () => {
    const { hash } = window.location;
    if (!hash) return;
    const id = hash.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const scrollToHashWithRetry = () => {
    // 첫 번째 스크롤
    scrollToHash();
    // 이미지/GIF 로딩 후 레이아웃 안정화되면 다시 스크롤
    setTimeout(scrollToHash, 500);
  };

  useEffect(() => {
    // 해시 변경만 발생해도 스크롤 처리
    const onHashChange = () => {
      scrollToHashWithRetry();
    };
    window.addEventListener('hashchange', onHashChange);
    // 초기 진입 시 해시가 있으면 스크롤
    setTimeout(scrollToHashWithRetry, 100);
    return () => {
      window.removeEventListener('hashchange', onHashChange);
    };
  }, []);

  const handleRouteChange = () => {
    // 라우트 전환 후 섹션이 렌더된 다음 스크롤
    setTimeout(scrollToHashWithRetry, 100);
  };

  const NotFound = () => {
    useEffect(() => {
      route('/', true);
    }, []);
    return null;
  };

  return (
    <Router onChange={handleRouteChange}>
      <CustomerLanding path="/" />
      <BusinessLanding path="/business" />
      <DownloadRedirect path="/download" />
      <AdminAppDownloadRedirect path="/admin-app-download" />
      <CenterRedirect path="/center/:centerId" />
      <ProductRedirect path="/product/:productId" />
      <NotFound default />
    </Router>
  );
}
